import CourseraPlusProductVariant from 'bundles/coursera-plus-common/constants/CourseraPlusProductVariant';
import type { CourseraPlusAcquisitionType } from 'bundles/coursera-plus-common/types/CourseraPlusAcquisitionType';
import type CartsV2 from 'bundles/naptimejs/resources/carts.v2';
import ProductType from 'bundles/payments-common/common/ProductType';
import createCartPromise from 'bundles/payments-common/utils/cartCreation/createCart';

/**
 * Create a Coursera Plus subscription cart. NOTE: Refer to ./createCart for more information.
 * @param {string} productId - The productId of the product to enroll in
 * @param {string | null} courseIdToGrantMembership - The courseId of the course in a s12n to also enroll in
 * @returns {Promise.<CartsV2>} ./createCart response.
 */
export default (
  productId?: string,
  courseIdToGrantMembership?: string,
  productItemId?: string,
  couponId?: number,
  currencyCode?: string,
  acquisitionType?: CourseraPlusAcquisitionType
): Promise<CartsV2> => {
  const promiseOptions = {
    productItems: [
      {
        productType: ProductType.COURSERA_PLUS_SUBSCRIPTION,
        productItemId: productItemId || CourseraPlusProductVariant.ANNUAL_NO_FREE_TRIAL,
        productAction: 'Buy',
        ...(productId || acquisitionType
          ? {
              metadata: {
                'org.coursera.payment.CourseraPlusSubscriptionCartItemMetadata': {
                  ...(acquisitionType ? { acquisitionType } : {}),
                  ...(productId
                    ? {
                        productEnrollmentInformation: {
                          productIdToEnroll: productId,
                          ...(courseIdToGrantMembership
                            ? {
                                courseIdToGrantMembership,
                              }
                            : {}),
                        },
                      }
                    : {}),
                },
              },
            }
          : {}),
      },
    ],
    couponId,
    ...(currencyCode ? { currencyCode } : {}),
  };

  return createCartPromise(promiseOptions);
};
